import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
    apiKey: "AIzaSyBJI8gy2I_weWqPCQE50vCaewOWCg0iF2g",
    authDomain: "learning-paths-54a8a.firebaseapp.com",
    projectId: "learning-paths-54a8a",
    storageBucket: "learning-paths-54a8a.firebasestorage.app",
    messagingSenderId: "1017681369590",
    appId: "1:1017681369590:web:304e9db4885ba787b74fd7",
    measurementId: "G-CGNZ03RHZP"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app); 